<template>
	<div class="exchanges">
		<Tou></Tou>
		<div class="w1500 bj-0 p-50 mt-50 mb-60 t-center exchanges1">
			<i class="el-icon-check f-50 B-700 ys-0 p-15" style="background: linear-gradient(0deg,#ff775b 0%, #e80b17 100%, #2989cc 100%);border-radius: 50%;"></i>
			<div class="f-20 mt-34" >
				<i v-if="stype==3">Congratulations, you've successfully redeemed *! Please check your Email for shipping information in one week.</i>
				<i v-else-if="stype!=3 &&  mail &&  mail.commodityName">Congratulations! You have successfully redeemed an Amazon Gift Card {{mail.commodityName}}!</i>
			</div>
			<div class="f-20 mb-30 mt-16" style="color: #666666;"  v-if="stype!=3 && mail && mail.card">voucher: <span style="color: #E60012;">{{mail.card}}</span></div>
			<div class="f-16 line-24 tips " style="color: #666666;margin: 0 auto;">
				<i class="iconfont icon-zhuyi"></i>
				✔ Successfully redeemed! You can find this order in "My Order" 
			</div>
			<div class="flex a-center j-center" style="margin: .65rem auto;">
				<div class="hangan hangan1 cur_pointer ys-0" @click="$router.push({name: 'myOrder'})">My order</div>
				<div class="hangan hangan2 cur_pointer" @click="$houtui()">Close</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Tou from '../../../zuzuzu/touss.vue'
	import Foot from '../../../zuzuzu/foot.vue'
	import {addresslist,spxiangqin2} from '@/api/PointsMall.js';
	export default {
		data() {
			return {
				radio: 1,
				max: '',
				mail: {commodityName:''},
				address:[],
				sid:'',
				stype:0
			}
		},
		components: {
			Tou,
			Foot,
		},
		created() {
			// this.sid = this.$route.query.id;
			this.sid = this.$route.params.id;
			this.stype = this.$route.query.type;
			spxiangqin2({id:this.sid}).then(shu=>{
				this.mail=shu.data
			})
			addresslist({name:''}).then(shu=>{
				if(shu.data.length>=1){
					this.address=shu.data
				}else{
					this.address=[]
				}
			})
			
		},
		methods: {
			// 提交兑换
			Duihuan(){
				lpkduihuan({id:this.sid}).then(s=>{
					// this.$message({
					//   showClose: true,
					//   message: shu.message,
					//   type: 'success',
					//   offset:'350',
					//   duration:0
					// });
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.exchanges{
		.biaotie span {display: inline-block;width: .08rem;height: .28rem;background: #e60012;border-radius: 4px;}
		::v-deep .el-radio__input.is-checked .el-radio__inner{
			border-color: #E60012;
			background: #ffffff;
		}
		::v-deep .el-radio {display: block;margin: 0 .25rem;}
		::v-deep .el-radio__inner{width: .24rem;height: .24rem;border-width: 2px;}
		::v-deep .el-radio__inner::after {background-color: #E60012;width: .12rem;height: .12rem;}
		::v-deep .el-radio__label,.el-radio__input.is-checked+.el-radio__label {font-size: .16rem;color: #666666;}
		::v-deep .el-radio {padding: .24rem;display: flex;}
		::v-deep .is-checked { background: #f7f7f7; border-radius: 10px;  }
		::v-deep .el-radio__label {display: flex;flex: 1;}
		.imgs {width: 2.46rem; height: 1.59rem; border-radius: 10px;}
		.anniu {}
		.hangan {border-radius: 100px; margin: 0 .3rem;}
		.hangan1 {padding: .12rem .35rem; background: linear-gradient(-26deg,#e70a16 0%, #ff785c 100%);}
		.hangan2 {padding: .12rem .45rem; background: #F6F6F8; }
	}


// ==========================================================================================================================================================================
// 响应式
@media screen and (max-width: 767px) {
	.exchanges .tips {width: 100%;}
}
</style>